import * as React from 'react';
import classNames from 'classnames';

import * as styles from './FiltersBackground.css';
import { ESectionType, TSectionType } from '../../types/sectionType';

import indexSrc from './assets/banner-bg.jpg';
import dailyRentSrc from './assets/daily-banner-bg.jpg';
import commercialSrc from './assets/commerce-banner-bg.jpg';
import saleSrc from './assets/sale-banner-bg.jpg';
import rentSrc from './assets/rent-banner-bg.jpg';
import newBuildingsSrc from './assets/new-banner-bg.png';

import indexSrc2x from './assets/banner-bg@2x.jpg';
import dailyRentSrc2x from './assets/daily-banner-bg@2x.jpg';
import commercialSrc2x from './assets/commerce-banner-bg@2x.jpg';
import saleSrc2x from './assets/sale-banner-bg@2x.jpg';
import rentSrc2x from './assets/rent-banner-bg@2x.jpg';
import newBuildingsSrc2x from './assets/new-banner-bg@2x.png';

export interface IFiltersBackgroundProps {
  section: TSectionType;
  imageUrl?: string;
  defaultImageUrl?: string;
  isDefaultImageAnimationEnabled: boolean;
}

const BackgroundImages: Record<string, string> = {
  index: indexSrc,
  'daily-rent': dailyRentSrc,
  commercial: commercialSrc,
  sale: saleSrc,
  rent: rentSrc,
  'new-buildings': newBuildingsSrc,
};

const BackgroundImagesHighRes: Record<string, string> = {
  index: indexSrc2x,
  'daily-rent': dailyRentSrc2x,
  commercial: commercialSrc2x,
  sale: saleSrc2x,
  rent: rentSrc2x,
  'new-buildings': newBuildingsSrc2x,
};

export function FiltersBackground({
  section,
  imageUrl,
  defaultImageUrl,
  isDefaultImageAnimationEnabled,
}: IFiltersBackgroundProps) {
  const backgroundImageUrl = imageUrl || defaultImageUrl;
  const imgClassName = imageUrl ? styles['old-image'] : styles['image'];

  return (
    <img
      className={classNames(
        imgClassName,
        isDefaultImageAnimationEnabled && styles['default-image-animation'],
        section === ESectionType.DailyRent && styles['daily-rent'],
      )}
      width="100%"
      height="100%"
      src={backgroundImageUrl}
      srcSet={`${backgroundImageUrl || BackgroundImagesHighRes[section]} 2x, ${backgroundImageUrl || BackgroundImages[section]} 1x`}
    />
  );
}
